import { useTranslation } from 'react-i18next';
import { useOneTimeReportStore } from '../../store';
import { useEffect } from 'react';
import { TextLabel, Textarea } from '@tonic-one/react';
import style from '../../index.module.less';

const Subject = () => {
  const { t } = useTranslation();
  //getter
  const subject = useOneTimeReportStore((store) => store.notification.subject);

  //setter
  const setSubject = useOneTimeReportStore((store) => store.setSubject);

  //register
  const register = useOneTimeReportStore(
    (store) => store.registerResetCallback
  );
  const unregister = useOneTimeReportStore(
    (store) => store.unregisterResetCallback
  );

  useEffect(() => {
    const cb = () => setSubject(t('reportCommon.emailSubject'));
    cb();

    register(cb);
    return () => unregister(cb);
  }, [t]);

  return (
    <>
      <TextLabel className={style.itemLabel}>
        {t('reportCommon.labels.subject')}:
      </TextLabel>
      <Textarea
        mt="1x"
        rows={1}
        width={400}
        placeholder={t('reportCommon.placeholders.subject')}
        value={subject}
        onChange={(e: any) => setSubject(e.target.value)}
      />
    </>
  );
};

export default Subject;
